import { BulletList, Button } from '@airtm/airtm-ui';
import { LOCAL_STORAGE } from '@constants';
import { useTranslation, Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function CorporateDocumentation() {
  const { t } = useTranslation(['ENTERPRISE_SIGNUP', 'ENTERPRISE_ALERTS']);
  const history = useHistory();

  const skip = () => {
    localStorage.removeItem(LOCAL_STORAGE.SHOW_DOCUMENTATION_SCREEN);
    history.push('/');
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="mt-9 mb-5">
        <h1>{t('CORPORATE_DOCUMENTATION_TITLE')}</h1>
        <p className="my-4">
          <Trans i18nKey="ENTERPRISE_SIGNUP:CORPORATE_DOCUMENTATION_DESCRIPTION" />
        </p>
        <BulletList>
          <li className="my-5">
            <p>{t('CORPORATE_DOCUMENTATION_1')}</p>
          </li>
          <li className="my-5">
            <p>{t('CORPORATE_DOCUMENTATION_2')}</p>
          </li>
          <li className="my-5">
            <p>{t('CORPORATE_DOCUMENTATION_3')}</p>
          </li>
        </BulletList>
        <Button
          component="a"
          href={t('ENTERPRISE_ALERTS:CORPORATE_DOCUMENTATION_FORM_LINK')}
          target="_blank"
          className="mr-3"
        >
          {t('CORPORATE_DOCUMENTATION_PRIMARY_BUTTON')}
        </Button>
        <Button variant="secondary" onClick={() => skip()}>
          {t('CORPORATE_DOCUMENTATION_SECONDARY_BUTTON')}
        </Button>
      </div>
    </div>
  );
}

export default CorporateDocumentation;
